var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "header-mega-menu-module",
      class: [{ show: _vm.subActive }, { "image-style": _vm.isImageStyle }],
      on: {
        mouseleave: function($event) {
          return _vm.onMouseLeave()
        }
      }
    },
    [
      _vm.isImageStyle
        ? _c("div", { staticClass: "image-grid" }, [
            _c("h3", { staticClass: "title" }, [
              _vm._v("\n      " + _vm._s(_vm.links.menu_title) + "\n      "),
              _c("small", [_vm._v(_vm._s(_vm.links.subtitle))])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "links flex" },
              _vm._l(_vm.links.children, function(link) {
                return _c(
                  "a",
                  {
                    key: link.id,
                    staticClass: "item",
                    attrs: { href: link.url }
                  },
                  [
                    _c("div", { staticClass: "image" }, [
                      _c("img", { attrs: { src: link.image, alt: link.title } })
                    ]),
                    _vm._v(" "),
                    _c("h4", [
                      _vm._v(
                        "\n          " + _vm._s(link.title) + "\n          "
                      ),
                      _c("small", [_vm._v(_vm._s(link.subtitle))])
                    ])
                  ]
                )
              }),
              0
            )
          ])
        : _c("div", { staticClass: "tile-grid flex" }, [
            _c("div", { staticClass: "left" }, [
              _c(
                "h3",
                { staticClass: "title" },
                [
                  _vm._v(
                    "\n        " + _vm._s(_vm.links.menu_title) + "\n        "
                  ),
                  _c("center", [
                    _c("i", [_c("small", [_vm._v(_vm._s(_vm.links.subtitle))])])
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "links flex flex-between" },
                _vm._l(_vm.links.children, function(link) {
                  return _c(
                    "a",
                    {
                      key: link.id,
                      staticClass: "link-large-gray",
                      attrs: { href: link.url }
                    },
                    [
                      _vm._v(
                        "\n          " + _vm._s(link.title) + "\n          "
                      ),
                      _c("br"),
                      _vm._v(" "),
                      _c("i", [_c("small", [_vm._v(_vm._s(link.subtitle))])])
                    ]
                  )
                }),
                0
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "grid-sidebar" }, [
              _c("h4", [_vm._v(_vm._s(_vm.links.menu_description))]),
              _vm._v(" "),
              _vm.links.menu_button_link !== ""
                ? _c(
                    "a",
                    {
                      staticClass: "button large white-border",
                      attrs: { href: _vm.links.menu_button_link }
                    },
                    [_vm._v(_vm._s(_vm.links.menu_button_text))]
                  )
                : _vm._e()
            ])
          ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ffc68cc", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ffc68cc","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/frontend/js/components/HeaderMegaMenu.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-7ffc68cc","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/frontend/js/components/HeaderMegaMenu.vue
// module chunks = 0